import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useRouteContext } from '~/routes/hooks'

const Dashboard = () => {
  const { t } = useTranslation()
  const { brand } = useRouteContext(Dashboard.name)
  return (
    <>
      <Helmet title={t('dashboard.title')} />
      <div className="h-full xy-center">
        {t('dashboard.title')}: {brand?.name}
      </div>
    </>
  )
}

export default Dashboard
